import type React from 'react'
import useFeatureFlags from '../../../../hooks/useFeatureFlags'
import HomeSettingsScreen from './HomeSettingsScreen'

interface HomeSettingsProps {
  hasRosteringAccessControlSettings?: boolean
  emarV2RoundTimings?: boolean
}

const HomeSettingsWrapper = () => {
  const flags = useFeatureFlags({
    flagNames: ['rostering_access_control_settings', 'emar_v2_round_timings']
  })?.data

  const flagsRosteringAccessControlSettingsEnabled =
    flags?.rostering_access_control_settings?.enabled

  const HomeSettingsWithProps =
    HomeSettingsScreen as React.ComponentType<HomeSettingsProps>

  return (
    <HomeSettingsWithProps
      hasRosteringAccessControlSettings={
        flagsRosteringAccessControlSettingsEnabled
      }
      emarV2RoundTimings={flags?.emar_v2_round_timings?.enabled ?? false}
    />
  )
}

export default HomeSettingsWrapper
